import { LoadingPage } from "@endya-conformite/ui-kit";
import { CQAxePage } from "@src/pages/controle-quinquennal/CQAxePage";
import { ReactElement } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { QuestionnaireAdminRoute } from "./components/QuestionnaireAdminRoute/QuestionnaireAdminRoute";
import { useSession } from "./data/session/UserSessionContext";
import { QuestionnaireAdminEditPage } from "./pages/admin/QuestionnaireAdminEditPage";
import { QuestionnaireAdminListPage } from "./pages/admin/QuestionnaireAdminListPage";
import { CQAxesPage } from "./pages/controle-quinquennal/CQAxesPage";
import { CQListPage } from "./pages/controle-quinquennal/CQListPage";
import { CQRapportPage } from "./pages/controle-quinquennal/CQRapportPage";
import { CQRemediationPage } from "./pages/controle-quinquennal/CQRemediationPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ForgotPassword } from "./pages/session/ForgotPassword/ForgotPassword";
import { ForgotPasswordMail } from "./pages/session/ForgotPassword/ForgotPasswordMail";
import { ForgotPasswordReset } from "./pages/session/ForgotPassword/ForgotPasswordReset";
import { ForgotPasswordSuccess } from "./pages/session/ForgotPassword/ForgotPasswordSuccess";
import { Login } from "./pages/session/Login/Login";
import { NewPassword } from "./pages/session/Login/NewPassword";

type PrivateRouteProps = {
  children: ReactElement;
};

function PrivateRoute({ children }: PrivateRouteProps) {
  const session = useSession();
  const { pathname, search } = useLocation();

  if (session.isInitializing) {
    return (
      <div style={{ minHeight: "100vh" }}>
        <LoadingPage withText={false} />
      </div>
    );
  }

  if (session.isConnected) return children;

  return (
    <Navigate to={`/login?url=${encodeURIComponent(pathname + search)}`} />
  );
}

export function Router() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/new-password/:userId" element={<NewPassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />}>
        <Route path="" element={<ForgotPasswordMail />} />
        <Route path="reset" element={<ForgotPasswordReset />} />
        <Route path="success" element={<ForgotPasswordSuccess />} />
      </Route>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <CQListPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/controle-quinquennal/:idEntreprise"
        element={
          <PrivateRoute>
            <CQAxesPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/controle-quinquennal/:idEntreprise/:idCQ/:idAxe"
        element={
          <PrivateRoute>
            <CQAxePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/controle-quinquennal/:idEntreprise/:idCQ/:idAxe/remediation"
        element={
          <PrivateRoute>
            <CQRemediationPage />
          </PrivateRoute>
        }
      />
      <Route
        path="controle-quinquennal/:idEntreprise/rapport"
        element={
          <PrivateRoute>
            <CQRapportPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/questionnaires"
        element={
          <PrivateRoute>
            <QuestionnaireAdminRoute>
              <QuestionnaireAdminListPage />
            </QuestionnaireAdminRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/questionnaires/:slug"
        element={
          <PrivateRoute>
            <QuestionnaireAdminRoute>
              <QuestionnaireAdminEditPage />
            </QuestionnaireAdminRoute>
          </PrivateRoute>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
